import SherpaClient from "./main";

export const addToWaitlist = async (teacherEmail) => {
  const response = await SherpaClient.post(`/waitlist/${teacherEmail}`);
  return response.data;
};
